import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FirebaseModule } from '../core/firebase/firebase.module';
import { RouterModule } from '@angular/router';
import { PagesState } from './pages.route';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotComponent } from './forgot/forgot.component';
import { RegistrationStepsComponent } from './registration-steps/registration-steps.component';
import { RegistrationStepComponent } from './registration-steps/steps/registration-step.component';
// import { ChildernAddStepComponent } from './registration-steps/steps/childern-add-step.component';
// import { BillingStepComponent } from './registration-steps/steps/billing-step.component';
// import { SuccessStepComponent } from './registration-steps/steps/success-step.component';
import { VerifyComponent } from './actions/verify/verify.component';
import { ActionsComponent } from './actions/actions.component';
import { ResetPasswordComponent } from './actions/password-reset/password-reset.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    declarations: [
        LoginComponent,
        ResetPasswordComponent,
        VerifyComponent,
        ActionsComponent,
        ForgotComponent,
        RegistrationStepsComponent,
        RegistrationStepComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(PagesState),
        FirebaseModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
		MatSelectModule,
		MatRadioModule,
		MatCheckboxModule
    ]
})
export class PagesModule { }
